<div class="desk">
    <app-modal-reservation></app-modal-reservation>
    <app-spinner></app-spinner>
    <app-modal-error-mobile></app-modal-error-mobile>
</div>